import { render, staticRenderFns } from "./ScheduledProjectsPage.vue?vue&type=template&id=247fd79e&scoped=true"
import script from "./ScheduledProjectsPage.vue?vue&type=script&lang=ts"
export * from "./ScheduledProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./ScheduledProjectsPage.vue?vue&type=style&index=0&id=247fd79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fd79e",
  null
  
)

export default component.exports